import { render, staticRenderFns } from "./BackgroundSelector.vue?vue&type=template&id=6665b709&scoped=true"
import script from "./BackgroundSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundSelector.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSelector.vue?vue&type=style&index=0&id=6665b709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665b709",
  null
  
)

export default component.exports